export const formatAddress = addressDetails => {
  return `${addressDetails.first_address_line}, ${addressDetails.city}, ${addressDetails.state}${
    addressDetails.zip_code ? `, ${addressDetails.zip_code}` : ""
  }`
}

export default { formatAddress }
